import { posterUrl, yearFromReleaseDate } from '../lib/tmdb.js';

// Generic media poster card. Accepts a movie or TV show shape; the server-side
// normalize() function ensures both expose `title` and `release_date`.
export default function PosterCard({ movie, onClick }) {
  const m = movie || {};
  const title = m.title || m.name || '';
  const year = yearFromReleaseDate(m.release_date || m.first_air_date);
  const isTv = m.media_type === 'tv';
  return (
    <button type="button" className="hb-poster" onClick={onClick} aria-label={`${title} — open details`}>
      <div className="hb-poster__art">
        <img src={posterUrl(m.poster_path)} alt="" loading="lazy" />
        {isTv && <span className="hb-poster__tv-badge">TV</span>}
      </div>
      <div className="hb-poster__spine">
        <span className="hb-poster__title">{title}</span>
        {year ? <span className="hb-poster__year">{year}</span> : null}
      </div>
    </button>
  );
}
